/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Befirst2Inputs */

const id_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadilah yang pertama meninggalkan ulasan untuk produk ini!`)
};

const ms_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadilah yang pertama meninggalkan ulasan untuk produk ini!`)
};

const da_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vær den første til at skrive en anmeldelse for dette produkt!`)
};

const de_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seien Sie der Erste, der eine Bewertung für dieses Produkt hinterlässt!`)
};

const en_us2_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Be the first to leave a review for this product!`)
};

const es_es2_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Sé el primero en dejar una reseña para este producto!`)
};

const es_mx2_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Sé el primero en dejar una reseña para este producto!`)
};

const fil_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maging una na mag-iwan ng review para sa produktong ito!`)
};

const fr_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez le premier à laisser un avis sur ce produit !`)
};

const it_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sii il primo a lasciare una recensione per questo prodotto!`)
};

const hu_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Légy az első, aki értékeli ezt a terméket!`)
};

const nl_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wees de eerste die een review achterlaat voor dit product!`)
};

const no_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli den første til å legge igjen en omtale for dette produktet!`)
};

const pl_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bądź pierwszy, który napisze recenzję tego produktu!`)
};

const pt_br2_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja o primeiro a deixar um comentário sobre este produto!`)
};

const pt_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja o primeiro a deixar uma avaliação para este produto!`)
};

const ro_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fii primul care lasă o recenzie pentru acest produs!`)
};

const fi_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ole ensimmäinen, joka jättää arvostelun tästä tuotteesta!`)
};

const sv_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli först med att lämna en recension för denna produkt!`)
};

const vi_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hãy là người đầu tiên để lại đánh giá cho sản phẩm này!`)
};

const tr_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu ürün için ilk yorumu bırakan siz olun!`)
};

const cs_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buďte první, kdo napíše recenzi na tento produkt!`)
};

const bg_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бъдете първият, който ще остави ревю за този продукт!`)
};

const ru_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будьте первым, кто напишет обзор на этот продукт!`)
};

const uk_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будьте першим, хто залишить відгук для цього продукту!`)
};

const ar_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كن أول من يترك مراجعة لهذا المنتج!`)
};

const hi_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस उत्पाद के लिए समीक्षा लिखने वाले पहले व्यक्ति बनें!`)
};

const th_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เป็นคนแรกที่เขียนรีวิวสำหรับผลิตภัณฑ์นี้!`)
};

const ja_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この製品の最初のレビューを書いてみませんか！`)
};

const zh_cn2_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成为第一个为该产品发表评论的人！`)
};

const zh_hant1_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成為第一個為該產品發表評論的人！`)
};

const ko_offerdetail_reviews_befirst2 = /** @type {(inputs: Offerdetail_Reviews_Befirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 제품에 대한 첫 리뷰를 남겨보세요!`)
};

/**
* | output |
* | --- |
* | "Be the first to leave a review for this product!" |
*
* @param {Offerdetail_Reviews_Befirst2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_befirst2 = /** @type {((inputs?: Offerdetail_Reviews_Befirst2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Befirst2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_befirst2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_befirst2(inputs)
	if (locale === "da") return da_offerdetail_reviews_befirst2(inputs)
	if (locale === "de") return de_offerdetail_reviews_befirst2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_befirst2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_befirst2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_befirst2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_befirst2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_befirst2(inputs)
	if (locale === "it") return it_offerdetail_reviews_befirst2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_befirst2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_befirst2(inputs)
	if (locale === "no") return no_offerdetail_reviews_befirst2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_befirst2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_befirst2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_befirst2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_befirst2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_befirst2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_befirst2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_befirst2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_befirst2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_befirst2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_befirst2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_befirst2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_befirst2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_befirst2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_befirst2(inputs)
	if (locale === "th") return th_offerdetail_reviews_befirst2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_befirst2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_befirst2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_befirst2(inputs)
	return ko_offerdetail_reviews_befirst2(inputs)
});
export { offerdetail_reviews_befirst2 as "offerDetail.reviews.beFirst" }